/**
 * Tablet-only hamburger button that opens the mobile sidebar drawer.
 * Mobile xs (<sm) uses the BottomNav instead, so it's hidden there.
 */

import React from "react";
import { Menu } from "lucide-react";

export default function MobileMenuButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="hidden sm:flex lg:hidden p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors duration-200"
      data-testid="mobile-menu-btn"
    >
      <Menu className="w-5 h-5" />
    </button>
  );
}
